// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatusItem-module__font-s-10___rMB_j {
  font-size: 10px !important;
}

.StatusItem-module__font-s-12___k7qr9 {
  font-size: 12px !important;
}

.StatusItem-module__font-s-13___cKzBO {
  font-size: 13px !important;
}

.StatusItem-module__font-s-14___wDgxC {
  font-size: 14px !important;
}

.StatusItem-module__font-s-15___PhZ2A {
  font-size: 15px !important;
}

.StatusItem-module__font-s-16___x4RwW {
  font-size: 16px !important;
}

.StatusItem-module__font-s-18___bgVvl {
  font-size: 18px !important;
}

.StatusItem-module__font-s-20___wR0cv {
  font-size: 20px !important;
}

.StatusItem-module__font-s-22___WWzec {
  font-size: 22px !important;
}

.StatusItem-module__font-s-28___bXi4L {
  font-size: 28px !important;
}

.StatusItem-module__font-w-400___QbpVC {
  font-weight: 400 !important;
}

.StatusItem-module__font-w-500___EQa15 {
  font-weight: 500 !important;
}

.StatusItem-module__font-w-600___fmkcD {
  font-weight: 600 !important;
}

.StatusItem-module__font-w-700___g7gUf {
  font-weight: 700 !important;
}

.StatusItem-module__p-5___tcJgq {
  padding: 5px !important;
}

.StatusItem-module__p-12___RnO1o {
  padding: 12px !important;
}

.StatusItem-module__p-16___yCYib {
  padding: 16px !important;
}

.StatusItem-module__p-30___yVDK6 {
  padding: 30px !important;
}

.StatusItem-module__p-b-0___U1TWo {
  padding-bottom: 0 !important;
}

.StatusItem-module__p-b-5___QWaEy {
  padding-bottom: 5px !important;
}

.StatusItem-module__p-b-10___m3c4M {
  padding-bottom: 10px !important;
}

.StatusItem-module__p-b-12___dy71J {
  padding-bottom: 12px !important;
}

.StatusItem-module__p-b-16___bLh1I {
  padding-bottom: 16px !important;
}

.StatusItem-module__p-b-18___idpfz {
  padding-bottom: 18px !important;
}

.StatusItem-module__p-b-20___oS5H5 {
  padding-bottom: 20px !important;
}

.StatusItem-module__p-b-25___Cb2pw {
  padding-bottom: 25px !important;
}

.StatusItem-module__p-b-30___RM1dk {
  padding-bottom: 30px !important;
}

.StatusItem-module__p-b-50___Un13V {
  padding-bottom: 50px !important;
}

.StatusItem-module__p-t-0___JNNyp {
  padding-top: 0 !important;
}

.StatusItem-module__p-t-12___XPMzE {
  padding-top: 12px !important;
}

.StatusItem-module__p-t-16___jDqBA {
  padding-top: 16px !important;
}

.StatusItem-module__p-t-18___fmck8 {
  padding-top: 18px !important;
}

.StatusItem-module__p-t-20___TUP85 {
  padding-top: 20px !important;
}

.StatusItem-module__p-t-30___g2byC {
  padding-top: 30px !important;
}

.StatusItem-module__p-t-40___pIXng {
  padding-top: 40px !important;
}

.StatusItem-module__p-t-50___c1ufB {
  padding-top: 50px !important;
}

.StatusItem-module__p-l-20___CQG8Q {
  padding-left: 20px !important;
}

.StatusItem-module__p-l-30___lCMVa {
  padding-left: 30px !important;
}

.StatusItem-module__p-l-40___MKaRb {
  padding-left: 40px !important;
}

.StatusItem-module__p-r-16___LPeTG {
  padding-right: 16px !important;
}

.StatusItem-module__p-r-20___FCoHi {
  padding-right: 20px !important;
}

.StatusItem-module__p-r-30___sBEnZ {
  padding-right: 30px !important;
}

.StatusItem-module__p-r-50___nxaKa {
  padding-right: 50px !important;
}

.StatusItem-module__p-r-60___BRjXY {
  padding-right: 60px !important;
}

.StatusItem-module__m-b-1___uR4D3 {
  margin-bottom: 1px !important;
}

.StatusItem-module__m-b-2___mBgYR {
  margin-bottom: 2px !important;
}

.StatusItem-module__m-b-6___oh3bD {
  margin-bottom: 6px !important;
}

.StatusItem-module__m-b-8___rBRUK {
  margin-bottom: 8px !important;
}

.StatusItem-module__m-b-10___Ov866 {
  margin-bottom: 10px !important;
}

.StatusItem-module__m-b-14___DGWf5 {
  margin-bottom: 14px !important;
}

.StatusItem-module__m-b-16___Cg1re {
  margin-bottom: 16px !important;
}

.StatusItem-module__m-b-20___B80N4 {
  margin-bottom: 20px !important;
}

.StatusItem-module__m-b-22___Z9GD5 {
  margin-bottom: 22px !important;
}

.StatusItem-module__m-b-24___J6wUV {
  margin-bottom: 24px !important;
}

.StatusItem-module__m-b-30___OOQla {
  margin-bottom: 30px !important;
}

.StatusItem-module__m-b-32___A4bK3 {
  margin-bottom: 32px !important;
}

.StatusItem-module__m-b-40___DG8JY {
  margin-bottom: 40px !important;
}

.StatusItem-module__m-t-2___Y_OKZ {
  margin-top: 2px !important;
}

.StatusItem-module__m-t-3____09M1 {
  margin-top: 3px !important;
}

.StatusItem-module__m-t-4___C_f32 {
  margin-top: 4px !important;
}

.StatusItem-module__m-t-5___AD0Z0 {
  margin-top: 5px !important;
}

.StatusItem-module__m-t-8____7c77 {
  margin-top: 8px !important;
}

.StatusItem-module__m-t-10___TYtDI {
  margin-top: 10px !important;
}

.StatusItem-module__m-t-15___kWucH {
  margin-top: 15px !important;
}

.StatusItem-module__m-t-16___uESaY {
  margin-top: 16px !important;
}

.StatusItem-module__m-t-20___qXB5I {
  margin-top: 20px !important;
}

.StatusItem-module__m-t-22___O9bEw {
  margin-top: 22px !important;
}

.StatusItem-module__m-t-30___n64pl {
  margin-top: 30px !important;
}

.StatusItem-module__m-t-32___Cvbfw {
  margin-top: 32px !important;
}

.StatusItem-module__m-l-auto___vv6MN {
  margin-left: auto !important;
}

.StatusItem-module__m-l-4___vawsD {
  margin-left: 4px !important;
}

.StatusItem-module__m-l-5___J9zgR {
  margin-left: 5px !important;
}

.StatusItem-module__m-l-6___rs_g8 {
  margin-left: 6px !important;
}

.StatusItem-module__m-l-8___vPXYU {
  margin-left: 8px !important;
}

.StatusItem-module__m-l-10___Acgy5 {
  margin-left: 10px !important;
}

.StatusItem-module__m-l-16___EP4xj {
  margin-left: 16px !important;
}

.StatusItem-module__m-l-20___apqkt {
  margin-left: 20px !important;
}

.StatusItem-module__m-l-24___s6uON {
  margin-left: 24px !important;
}

.StatusItem-module__m-l-30___eAIw4 {
  margin-left: 30px !important;
}

.StatusItem-module__m-l-35___UtLdC {
  margin-left: 35px !important;
}

.StatusItem-module__m-l-40___f29OU {
  margin-left: 40px !important;
}

.StatusItem-module__m-r-8___OXxlb {
  margin-right: 8px !important;
}

.StatusItem-module__m-r-10___oUkJE {
  margin-right: 10px !important;
}

.StatusItem-module__m-r-16___vj52M {
  margin-right: 16px !important;
}

.StatusItem-module__m-r-20___zZ0gR {
  margin-right: 20px !important;
}

.StatusItem-module__m-r-24___ZEKdg {
  margin-right: 24px !important;
}

.StatusItem-module__m-r-30___TbnOK {
  margin-right: 30px !important;
}

.StatusItem-module__m-r-40___YXipW {
  margin-right: 40px !important;
}

.StatusItem-module__border-r-3___X_HWd {
  border-radius: 3px !important;
}

.StatusItem-module__border-r-4___nnwn4 {
  border-radius: 4px !important;
}

.StatusItem-module__border-r-6___jwzLk {
  border-radius: 6px !important;
}

.StatusItem-module__border-r-10___vAIUL {
  border-radius: 10px !important;
}

.StatusItem-module__border-r-12___u6lhT {
  border-radius: 12px !important;
}

.StatusItem-module__border-r-16___fyAMy {
  border-radius: 16px !important;
}

.StatusItem-module__border-r-50___ltL76 {
  border-radius: 50% !important;
}

.StatusItem-module__primary-border___TDxnD {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.StatusItem-module__primary-border-b___rR25e {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.StatusItem-module__primary-border-t___PZN6g {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.StatusItem-module__primary-border-l___hYVWI {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.StatusItem-module__primary-border-r___XNDVC {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.StatusItem-module__secondary-border___Qc30B {
  border: 1px solid #637768;
}

.StatusItem-module__secondary-border-b___TySnv {
  border-bottom: 1px solid #637768;
}

.StatusItem-module__secondary-border-t___DaknQ {
  border-top: 1px solid #637768;
}

.StatusItem-module__secondary-border-l___M2vdF {
  border-left: 1px solid #637768;
}

.StatusItem-module__secondary-border-r___JCHmM {
  border-right: 1px solid #637768;
}

.StatusItem-module__gap-0___bwCid {
  gap: 0 !important;
}

.StatusItem-module__gap-2___fcXYc {
  gap: 2px !important;
}

.StatusItem-module__gap-4___BsnF8 {
  gap: 4px !important;
}

.StatusItem-module__gap-5___a4Xpr {
  gap: 5px !important;
}

.StatusItem-module__gap-6___Plxre {
  gap: 6px !important;
}

.StatusItem-module__gap-8___lOeSC {
  gap: 8px !important;
}

.StatusItem-module__gap-10___DR7po {
  gap: 10px !important;
}

.StatusItem-module__gap-12___XUmI1 {
  gap: 12px !important;
}

.StatusItem-module__gap-14___qUdMC {
  gap: 14px !important;
}

.StatusItem-module__gap-16___TuZoJ {
  gap: 16px !important;
}

.StatusItem-module__gap-18___f5OQ8 {
  gap: 18px !important;
}

.StatusItem-module__gap-20___fbQHd {
  gap: 20px !important;
}

.StatusItem-module__gap-24___TwtX8 {
  gap: 24px !important;
}

.StatusItem-module__gap-26___gQZfW {
  gap: 26px !important;
}

.StatusItem-module__gap-30___ZExau {
  gap: 30px !important;
}

.StatusItem-module__gap-32___vtx5U {
  gap: 32px !important;
}

.StatusItem-module__gap-40___Lx9eZ {
  gap: 40px !important;
}

.StatusItem-module__gap-50___VOwea {
  gap: 50px !important;
}

.StatusItem-module__flex-1___VjGYj {
  flex: 1;
}

.StatusItem-module__flex-none___TaT55 {
  flex: none !important;
}

.StatusItem-module__flex-column___xaUi8 {
  display: flex;
  flex-direction: column !important;
}

.StatusItem-module__flex-row____sJLL {
  display: flex;
  flex-direction: row !important;
}

.StatusItem-module__vertically-centered___wHSnf {
  display: flex;
  align-items: center !important;
}

.StatusItem-module__horizontally-centered___liAdM {
  display: flex;
  justify-content: center !important;
}

.StatusItem-module__horizontally-end___Ewpd4 {
  display: flex;
  justify-content: end !important;
}

.StatusItem-module__vertically-start___dVY7m {
  display: flex;
  align-items: start !important;
}

.StatusItem-module__space-between___o72wu {
  display: flex;
  justify-content: space-between !important;
}

.StatusItem-module__flex-wrap___dEWXv {
  flex-wrap: wrap !important;
}

.StatusItem-module__height-100___slxKw {
  height: 100%;
}

.StatusItem-module__width-50___oHRBk {
  width: 50% !important;
}

.StatusItem-module__width-100___hAd_a {
  width: 100%;
}

.StatusItem-module__cursor-pointer___FhstA {
  cursor: pointer;
}

.StatusItem-module__cursor-not-allowed___lo_FU {
  cursor: not-allowed !important;
}

.StatusItem-module__absolute-centered___ij6Nt {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.StatusItem-module__absolute___dQwJG {
  position: absolute;
}

.StatusItem-module__relative___o8WM6 {
  position: relative;
}

.StatusItem-module__fixed___TVopK {
  position: fixed;
}

.StatusItem-module__visible___yPH5X {
  opacity: 1;
}

.StatusItem-module__invisible___Q7Izs {
  opacity: 0;
}

.StatusItem-module__col-90___hwder {
  width: 90% !important;
}

.StatusItem-module__col-auto___V7Rld {
  width: auto !important;
}

.StatusItem-module__medical-tabs___wxBkx {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.StatusItem-module__medical-table-new___irMmE {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.StatusItem-module__medical-table-new___irMmE:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.StatusItem-module__medical-table-new___irMmE::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.StatusItem-module__medical-table-new___irMmE::-webkit-scrollbar-track {
  display: none;
}
.StatusItem-module__medical-table-new___irMmE.StatusItem-module__no-pagination___lriqf {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.StatusItem-module__medical-table-new___irMmE.StatusItem-module__no-pagination___lriqf:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.StatusItem-module__medical-table-new___irMmE.StatusItem-module__no-pagination___lriqf::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.StatusItem-module__medical-table-new___irMmE.StatusItem-module__no-pagination___lriqf::-webkit-scrollbar-track {
  display: none;
}

.StatusItem-module__medical-table-empty____PXXI {
  padding: 14px 40px !important;
}

.StatusItem-module__icon-btn___kq34O {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.StatusItem-module__search-icon___pMqqW {
  width: 24px;
  height: 24px;
  align-self: center;
}

.StatusItem-module__disable-select____kcjx {
  user-select: none;
}

.StatusItem-module__break-word___NsYeX {
  word-break: break-word;
}

.StatusItem-module__popup-clear-btn___aYxgn {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.StatusItem-module__scroll-m-b-20___won5Q {
  scroll-margin-bottom: 20px;
}

.StatusItem-module__container___bmVtn {
  display: flex;
}
.StatusItem-module__container___bmVtn .StatusItem-module__icon___SBY87 {
  width: 20px;
  height: 20px;
}
.StatusItem-module__container___bmVtn .StatusItem-module__text___oDpE9 {
  font-family: var(--font-family);
  font-weight: 400;
  font-style: normal;
  line-height: 150%;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/ScheduledCallsFragment/ScheduledCallsList/items/StatusItem/StatusItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;AA8pBF;AA5pBE;EACE,WAAA;EACA,YAAA;AA8pBJ;AA3pBE;EEgBA,+BApBO;EAqBP,gBAFmD;EFbjD,kBAAA;EACA,iBAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  display: flex;\n\n  .icon {\n    width: 20px;\n    height: 20px;\n  }\n\n  .text {\n    @include get-font($roboto);\n    font-style: normal;\n    line-height: 150%;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `StatusItem-module__font-s-10___rMB_j`,
	"fontS12": `StatusItem-module__font-s-12___k7qr9`,
	"fontS13": `StatusItem-module__font-s-13___cKzBO`,
	"fontS14": `StatusItem-module__font-s-14___wDgxC`,
	"fontS15": `StatusItem-module__font-s-15___PhZ2A`,
	"fontS16": `StatusItem-module__font-s-16___x4RwW`,
	"fontS18": `StatusItem-module__font-s-18___bgVvl`,
	"fontS20": `StatusItem-module__font-s-20___wR0cv`,
	"fontS22": `StatusItem-module__font-s-22___WWzec`,
	"fontS28": `StatusItem-module__font-s-28___bXi4L`,
	"fontW400": `StatusItem-module__font-w-400___QbpVC`,
	"fontW500": `StatusItem-module__font-w-500___EQa15`,
	"fontW600": `StatusItem-module__font-w-600___fmkcD`,
	"fontW700": `StatusItem-module__font-w-700___g7gUf`,
	"p5": `StatusItem-module__p-5___tcJgq`,
	"p12": `StatusItem-module__p-12___RnO1o`,
	"p16": `StatusItem-module__p-16___yCYib`,
	"p30": `StatusItem-module__p-30___yVDK6`,
	"pB0": `StatusItem-module__p-b-0___U1TWo`,
	"pB5": `StatusItem-module__p-b-5___QWaEy`,
	"pB10": `StatusItem-module__p-b-10___m3c4M`,
	"pB12": `StatusItem-module__p-b-12___dy71J`,
	"pB16": `StatusItem-module__p-b-16___bLh1I`,
	"pB18": `StatusItem-module__p-b-18___idpfz`,
	"pB20": `StatusItem-module__p-b-20___oS5H5`,
	"pB25": `StatusItem-module__p-b-25___Cb2pw`,
	"pB30": `StatusItem-module__p-b-30___RM1dk`,
	"pB50": `StatusItem-module__p-b-50___Un13V`,
	"pT0": `StatusItem-module__p-t-0___JNNyp`,
	"pT12": `StatusItem-module__p-t-12___XPMzE`,
	"pT16": `StatusItem-module__p-t-16___jDqBA`,
	"pT18": `StatusItem-module__p-t-18___fmck8`,
	"pT20": `StatusItem-module__p-t-20___TUP85`,
	"pT30": `StatusItem-module__p-t-30___g2byC`,
	"pT40": `StatusItem-module__p-t-40___pIXng`,
	"pT50": `StatusItem-module__p-t-50___c1ufB`,
	"pL20": `StatusItem-module__p-l-20___CQG8Q`,
	"pL30": `StatusItem-module__p-l-30___lCMVa`,
	"pL40": `StatusItem-module__p-l-40___MKaRb`,
	"pR16": `StatusItem-module__p-r-16___LPeTG`,
	"pR20": `StatusItem-module__p-r-20___FCoHi`,
	"pR30": `StatusItem-module__p-r-30___sBEnZ`,
	"pR50": `StatusItem-module__p-r-50___nxaKa`,
	"pR60": `StatusItem-module__p-r-60___BRjXY`,
	"mB1": `StatusItem-module__m-b-1___uR4D3`,
	"mB2": `StatusItem-module__m-b-2___mBgYR`,
	"mB6": `StatusItem-module__m-b-6___oh3bD`,
	"mB8": `StatusItem-module__m-b-8___rBRUK`,
	"mB10": `StatusItem-module__m-b-10___Ov866`,
	"mB14": `StatusItem-module__m-b-14___DGWf5`,
	"mB16": `StatusItem-module__m-b-16___Cg1re`,
	"mB20": `StatusItem-module__m-b-20___B80N4`,
	"mB22": `StatusItem-module__m-b-22___Z9GD5`,
	"mB24": `StatusItem-module__m-b-24___J6wUV`,
	"mB30": `StatusItem-module__m-b-30___OOQla`,
	"mB32": `StatusItem-module__m-b-32___A4bK3`,
	"mB40": `StatusItem-module__m-b-40___DG8JY`,
	"mT2": `StatusItem-module__m-t-2___Y_OKZ`,
	"mT3": `StatusItem-module__m-t-3____09M1`,
	"mT4": `StatusItem-module__m-t-4___C_f32`,
	"mT5": `StatusItem-module__m-t-5___AD0Z0`,
	"mT8": `StatusItem-module__m-t-8____7c77`,
	"mT10": `StatusItem-module__m-t-10___TYtDI`,
	"mT15": `StatusItem-module__m-t-15___kWucH`,
	"mT16": `StatusItem-module__m-t-16___uESaY`,
	"mT20": `StatusItem-module__m-t-20___qXB5I`,
	"mT22": `StatusItem-module__m-t-22___O9bEw`,
	"mT30": `StatusItem-module__m-t-30___n64pl`,
	"mT32": `StatusItem-module__m-t-32___Cvbfw`,
	"mLAuto": `StatusItem-module__m-l-auto___vv6MN`,
	"mL4": `StatusItem-module__m-l-4___vawsD`,
	"mL5": `StatusItem-module__m-l-5___J9zgR`,
	"mL6": `StatusItem-module__m-l-6___rs_g8`,
	"mL8": `StatusItem-module__m-l-8___vPXYU`,
	"mL10": `StatusItem-module__m-l-10___Acgy5`,
	"mL16": `StatusItem-module__m-l-16___EP4xj`,
	"mL20": `StatusItem-module__m-l-20___apqkt`,
	"mL24": `StatusItem-module__m-l-24___s6uON`,
	"mL30": `StatusItem-module__m-l-30___eAIw4`,
	"mL35": `StatusItem-module__m-l-35___UtLdC`,
	"mL40": `StatusItem-module__m-l-40___f29OU`,
	"mR8": `StatusItem-module__m-r-8___OXxlb`,
	"mR10": `StatusItem-module__m-r-10___oUkJE`,
	"mR16": `StatusItem-module__m-r-16___vj52M`,
	"mR20": `StatusItem-module__m-r-20___zZ0gR`,
	"mR24": `StatusItem-module__m-r-24___ZEKdg`,
	"mR30": `StatusItem-module__m-r-30___TbnOK`,
	"mR40": `StatusItem-module__m-r-40___YXipW`,
	"borderR3": `StatusItem-module__border-r-3___X_HWd`,
	"borderR4": `StatusItem-module__border-r-4___nnwn4`,
	"borderR6": `StatusItem-module__border-r-6___jwzLk`,
	"borderR10": `StatusItem-module__border-r-10___vAIUL`,
	"borderR12": `StatusItem-module__border-r-12___u6lhT`,
	"borderR16": `StatusItem-module__border-r-16___fyAMy`,
	"borderR50": `StatusItem-module__border-r-50___ltL76`,
	"primaryBorder": `StatusItem-module__primary-border___TDxnD`,
	"primaryBorderB": `StatusItem-module__primary-border-b___rR25e`,
	"primaryBorderT": `StatusItem-module__primary-border-t___PZN6g`,
	"primaryBorderL": `StatusItem-module__primary-border-l___hYVWI`,
	"primaryBorderR": `StatusItem-module__primary-border-r___XNDVC`,
	"secondaryBorder": `StatusItem-module__secondary-border___Qc30B`,
	"secondaryBorderB": `StatusItem-module__secondary-border-b___TySnv`,
	"secondaryBorderT": `StatusItem-module__secondary-border-t___DaknQ`,
	"secondaryBorderL": `StatusItem-module__secondary-border-l___M2vdF`,
	"secondaryBorderR": `StatusItem-module__secondary-border-r___JCHmM`,
	"gap0": `StatusItem-module__gap-0___bwCid`,
	"gap2": `StatusItem-module__gap-2___fcXYc`,
	"gap4": `StatusItem-module__gap-4___BsnF8`,
	"gap5": `StatusItem-module__gap-5___a4Xpr`,
	"gap6": `StatusItem-module__gap-6___Plxre`,
	"gap8": `StatusItem-module__gap-8___lOeSC`,
	"gap10": `StatusItem-module__gap-10___DR7po`,
	"gap12": `StatusItem-module__gap-12___XUmI1`,
	"gap14": `StatusItem-module__gap-14___qUdMC`,
	"gap16": `StatusItem-module__gap-16___TuZoJ`,
	"gap18": `StatusItem-module__gap-18___f5OQ8`,
	"gap20": `StatusItem-module__gap-20___fbQHd`,
	"gap24": `StatusItem-module__gap-24___TwtX8`,
	"gap26": `StatusItem-module__gap-26___gQZfW`,
	"gap30": `StatusItem-module__gap-30___ZExau`,
	"gap32": `StatusItem-module__gap-32___vtx5U`,
	"gap40": `StatusItem-module__gap-40___Lx9eZ`,
	"gap50": `StatusItem-module__gap-50___VOwea`,
	"flex1": `StatusItem-module__flex-1___VjGYj`,
	"flexNone": `StatusItem-module__flex-none___TaT55`,
	"flexColumn": `StatusItem-module__flex-column___xaUi8`,
	"flexRow": `StatusItem-module__flex-row____sJLL`,
	"verticallyCentered": `StatusItem-module__vertically-centered___wHSnf`,
	"horizontallyCentered": `StatusItem-module__horizontally-centered___liAdM`,
	"horizontallyEnd": `StatusItem-module__horizontally-end___Ewpd4`,
	"verticallyStart": `StatusItem-module__vertically-start___dVY7m`,
	"spaceBetween": `StatusItem-module__space-between___o72wu`,
	"flexWrap": `StatusItem-module__flex-wrap___dEWXv`,
	"height100": `StatusItem-module__height-100___slxKw`,
	"width50": `StatusItem-module__width-50___oHRBk`,
	"width100": `StatusItem-module__width-100___hAd_a`,
	"cursorPointer": `StatusItem-module__cursor-pointer___FhstA`,
	"cursorNotAllowed": `StatusItem-module__cursor-not-allowed___lo_FU`,
	"absoluteCentered": `StatusItem-module__absolute-centered___ij6Nt`,
	"absolute": `StatusItem-module__absolute___dQwJG`,
	"relative": `StatusItem-module__relative___o8WM6`,
	"fixed": `StatusItem-module__fixed___TVopK`,
	"visible": `StatusItem-module__visible___yPH5X`,
	"invisible": `StatusItem-module__invisible___Q7Izs`,
	"col90": `StatusItem-module__col-90___hwder`,
	"colAuto": `StatusItem-module__col-auto___V7Rld`,
	"medicalTabs": `StatusItem-module__medical-tabs___wxBkx`,
	"medicalTableNew": `StatusItem-module__medical-table-new___irMmE`,
	"noPagination": `StatusItem-module__no-pagination___lriqf`,
	"medicalTableEmpty": `StatusItem-module__medical-table-empty____PXXI`,
	"iconBtn": `StatusItem-module__icon-btn___kq34O`,
	"searchIcon": `StatusItem-module__search-icon___pMqqW`,
	"disableSelect": `StatusItem-module__disable-select____kcjx`,
	"breakWord": `StatusItem-module__break-word___NsYeX`,
	"popupClearBtn": `StatusItem-module__popup-clear-btn___aYxgn`,
	"scrollMB20": `StatusItem-module__scroll-m-b-20___won5Q`,
	"container": `StatusItem-module__container___bmVtn`,
	"icon": `StatusItem-module__icon___SBY87`,
	"text": `StatusItem-module__text___oDpE9`
};
module.exports = ___CSS_LOADER_EXPORT___;
